import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CryptoService {
    constructor() {}
       encryptData(data: string): string {
        try {
            // Simple base64 encoding for URL safety
            const encodedData = btoa(data);
            return encodedData;
        } catch (e) {
            console.error('Encryption failed:', e);
            return '';
        }
    }

    decryptData(encryptedData: string): string {
        try {
            // Simple base64 decoding
            const decodedData = atob(encryptedData);
            return decodedData;
        } catch (e) {
            console.error('Decryption failed:', e);
            return '';
        }
    }
} 